/**
 * Returns the value, or the min or max if the value is outside those bounds (which are inclusive).
 */
export function clamp(value: number, min: number, max: number): number {
  if (max < min) {
    return NaN;
  }
  return Math.min(Math.max(value, min), max);
}
